<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
    <div
        class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">
        <!-- Header -->
        <div class="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-slate-100 shadow-sm">
            <div class="flex items-center gap-4 px-5 py-4">
                <!-- Optional back button (currently triggered by clicking text or icon) -->
                <!-- <button class="h-10 w-10 grid place-items-center rounded-2xl hover:bg-slate-50 active:scale-95 transition-all" (click)="toBack()">
          <span class="material-symbols-outlined text-slate-700">arrow_back</span>
        </button> -->
                <div class="flex-1">
                    <h1 class="text-xl font-black text-slate-800 tracking-tight" (click)="toBack()">{{ 'วันเช็คอิน - เช็คเอาต์' | translate : 'checkin' }}</h1>
                    <p class="text-xs font-medium text-slate-500 mt-0.5">{{ 'เลือกช่วงเวลาที่คุณต้องการเข้าพัก' | translate : 'checkin' }}</p>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div class="flex-1 overflow-y-auto w-full px-5 pt-5 pb-32 space-y-4">
            <!-- Date Display Box -->
            <button
                class="w-full rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm hover:border-blue-300 hover:shadow-md transition-all group flex items-center gap-4">
                <div
                    class="w-12 h-12 rounded-xl bg-blue-50 flex items-center justify-center shrink-0 border border-blue-100 group-hover:bg-blue-500 transition-colors">
                    <span class="material-symbols-outlined text-blue-500 group-hover:text-white transition-colors"
                        style="font-size:1.5rem">calendar_month</span>
                </div>
                <div class="flex-1 min-w-0">
                    <div class="text-[11px] font-semibold text-slate-400 uppercase tracking-wider mb-1">{{ 'ระยะเวลาเข้าพัก' | translate : 'checkin' }}
                    </div>
                    <div class="text-[15px] font-bold text-slate-800 flex items-center gap-2">
                        @if (dateRange[0]) {
                        <span class="truncate">{{dateRange[0] | thaidate}}</span>
                        @if (dateRange[1]) {
                        <span class="text-slate-300">→</span>
                        <span class="truncate">{{dateRange[1] | thaidate}}</span>
                        } @else {
                        <span class="text-slate-300">→</span>
                        <span class="text-slate-400 font-medium">{{ 'เลือกวันเช็คเอาต์' | translate : 'checkin' }}</span>
                        }
                        } @else {
                        <span class="text-slate-400 font-medium">{{ 'ยังไม่ได้เลือกวันที่' | translate : 'checkin' }}</span>
                        }
                    </div>
                </div>
            </button>

            <!-- Calendar -->
            <div class="rounded-3xl border border-slate-100 shadow-sm overflow-hidden bg-white p-2">
                <!-- <p-datepicker
                    class="w-full flex justify-center [&_.p-datepicker]:border-none [&_.p-datepicker]:shadow-none"
                    [(ngModel)]="dateRange" selectionMode="range" placeholder="เลือกช่วงวันที่" [numberOfMonths]="12"
                    [showOtherMonths]="true" inline="true" [selectOtherMonths]="true" (onSelect)="updateDate()">
                </p-datepicker> -->
                <p-datepicker class="w-full vertical" [(ngModel)]="dateRange" selectionMode="range" [placeholder]="'เลือกช่วงวันที่' | translate : 'checkin'"
                    [numberOfMonths]="12" [showOtherMonths]="true" [inline]="true" [selectOtherMonths]="true"
                    (onSelect)="updateDate()"></p-datepicker>
            </div>
        </div>

        <!-- Bottom bar (fixed to viewport) -->
        <div
            class="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-md border-t border-slate-100 p-5 z-50 shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
            <button
                class="w-full rounded-2xl py-3.5 text-sm font-bold text-white transition-all shadow-md shadow-blue-300 flex flex-col items-center justify-center min-h-[52px]"
                [ngClass]="nights() == 0 ? 'cursor-not-allowed bg-slate-300 shadow-none' : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 active:scale-[0.98]'"
                (click)="nights() > 0 && submit()">
                @if (dateRange[0] && dateRange[1]) {
                <div class="flex items-center gap-2">
                    {{ 'ยืนยันเลือก {n} คืน' | translate : { module: 'checkin', n: nights() } }}
                    <span class="material-symbols-outlined text-white/80" style="font-size:1.1rem">check_circle</span>
                </div>
                } @else {
                <span class="text-base">{{ 'เลือกวันที่เข้าพัก' | translate : 'checkin' }}</span>
                }
            </button>
        </div>
    </div>
</div>